import { apiUrl, normalizeAssetUrl } from '../config/api';

export async function fetchBrandImageUrl(type) {
  const response = await fetch(apiUrl(`/imageUpload/${type}`));

  if (!response.ok) {
    return null;
  }

  const data = await response.json();

  if (!data.imageUrl) {
    return null;
  }

  return normalizeAssetUrl(data.imageUrl);
}

export function updateDocumentFavicon(url) {
  if (!url) {
    return;
  }

  let cleanUrl = url;
  if (!cleanUrl.startsWith('http://') && !cleanUrl.startsWith('https://') && !cleanUrl.startsWith('/')) {
    cleanUrl = `/${cleanUrl}`;
  }

  let type = 'image/x-icon';
  if (cleanUrl.endsWith('.svg')) {
    type = 'image/svg+xml';
  } else if (cleanUrl.endsWith('.png')) {
    type = 'image/png';
  } else if (cleanUrl.endsWith('.ico')) {
    type = 'image/x-icon';
  } else if (cleanUrl.endsWith('.jpg') || cleanUrl.endsWith('.jpeg')) {
    type = 'image/jpeg';
  }

  // Remove existing icon links to force browsers to reload the tab favicon
  const existingLinks = document.querySelectorAll("link[rel*='icon']");
  existingLinks.forEach((el) => el.remove());

  const newLink = document.createElement('link');
  newLink.id = 'favicon';
  newLink.rel = 'icon';
  newLink.type = type;
  newLink.href = cleanUrl;

  document.head.appendChild(newLink);
}
